import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IGatewayResponse } from '@/Module/Core/Model/ApiModel';
import type { IRubikaPaymentRequest, IRubikaPaymentResponse } from '@/Module/Subscription/Model/ApiModel';
import { SubscriptionService } from '@/Module/Subscription/Service';

export const rubikaPaymentRequestAction = createAsyncThunk<IGatewayResponse<IRubikaPaymentResponse>, IRubikaPaymentRequest>(
  'subscription/rubika-payment-request',
  (req, { signal, rejectWithValue }) => {
    return SubscriptionService.rubikaPaymentRequest(
      {
        ...req,
      },
      signal,
      { disabledAutoError: true },
    )
      .then(({ data }) => data)
      .catch(rejectWithValue);
  },
);
